import React, { useState } from 'react';
import { FaSortDown } from 'react-icons/fa6';
import { Modal } from '../../../../components';

import { closeBlack } from '../../../../assets/Base64Image';
import { BlackWarning } from '../../../../assets/svg-image/common';
import RowBetween from '../../../../components/Layout/RowBetween';
import ColumnCenter from '../../../../components/Layout/ColumnCenter';
import SquadSemiBoldText from '../../../../components/Text/SquadSemiBoldText';
import PingFangMediumText from '../../../../components/Text/PingFangMediumText';
import RowCenter from '../../../../components/Layout/RowCenter';
import SquadBoldText from '../../../../components/Text/SquadBoldText';
import PingFangSemiBoldText from '../../../../components/Text/PingFangSemiBoldText';
import SquadRegularText from '../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../components/Text/PingFangRegularText';
import Button from '../../../../components/Button';

const ProblemReportModal: React.FC<Props> = ({
  onClose,
  onConfirm,
  isEnglish,
  optionKeys,
}) => {
  const [selectedOption, setSelectedOption] = useState<string>();
  const [showOption, setShowOption] = useState<boolean>(false);
  return (
    <Modal
      style={{ width: 338, padding: 'unset', paddingBottom: '26px', borderRadius: 42 }}
    >
      {/* 图标 */}
      <RowCenter>
        <img src={BlackWarning} style={{ width: '72px', height: '71px', marginTop: '-35px' }} />
      </RowCenter>

      {/* 关闭图标 */}
      <div
        onClick={() => onClose()}
        style={{ padding: '10px', width: '30px', height: '30px', marginLeft: 'auto', marginRight: '10px', marginTop: '-20px' }}
      >
        <img src={closeBlack} style={{ width: 14, height: 14 }} />
      </div>

      {
        isEnglish ? (
          <SquadBoldText fontSize={22} textAlign={'center'}>
            Report
          </SquadBoldText>
        ) : (
          <PingFangSemiBoldText fontSize={22} textAlign={'center'}>
            柜子问题反馈
          </PingFangSemiBoldText>
        )
      }
      {
        isEnglish ? (
          <SquadRegularText marginTop={15} lineHeight={18} textAlign={'center'}>
            Why is the cubicle not ready for use?
          </SquadRegularText>
        ) : (
          <PingFangRegularText marginTop={15} lineHeight={18} textAlign={'center'}>
            无法使用的原因
          </PingFangRegularText>
        )
      }

      <div onClick={() => setShowOption(!showOption)} style={{ width: 312, height: 60, background: '#FFFFFF', borderRadius: 13, border: '1px solid rgba(151,151,151,0.2)', marginLeft: 'auto', marginRight: 'auto', marginTop: 15 }}>
        <RowBetween style={{ height: 60 }}>
          <ColumnCenter style={{ marginLeft: '20px' }}>
            {
              !selectedOption ? (
                <div style={{ fontSize: '14px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '18px', opacity: 0.3 }}>
                  Choose a reason here...
                </div>
              ) : (
                <div style={{ fontSize: '14px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '18px' }}>
                  {selectedOption}
                </div>
              )
            }
          </ColumnCenter>
          <ColumnCenter style={{ marginRight: '15px' }}>
            <FaSortDown style={{ fontSize: '18px', marginTop: '-10px' }} />
          </ColumnCenter>
        </RowBetween>
      </div>
      {
        showOption && (
          <div style={{ width: 312, background: '#FFFFFF', boxShadow: '0px 2px 20px 0px rgba(0,0,0,0.16)', borderRadius: 13, marginLeft: 'auto', marginRight: 'auto' }}>
            {
              optionKeys.map((key) => {
                if (key === 'Dirty') {
                  return (
                    <div
                      onClick={() => {
                        setSelectedOption(key);
                        setShowOption(false);
                      }}
                      style={{ borderRadius: '18px 18px 0 0', height: '35px', background: selectedOption === key ? '#00B595' : undefined }}
                    >
                      {
                        isEnglish ? (
                          <SquadSemiBoldText fontSize={16} lineHeight={35} color={selectedOption === key ? '#FFFFFF' : '#11202B'} marginLeft={20}>
                            Dirty
                          </SquadSemiBoldText>
                        ) : (
                          <PingFangMediumText fontSize={16} lineHeight={35} color={selectedOption === key ? '#FFFFFF' : '#11202B'} marginLeft={20}>
                            脏污
                          </PingFangMediumText>
                        )
                      }
                    </div>
                  );
                }
                if (key === 'Door is not working') {
                  return (
                    <div
                      onClick={() => {
                        setSelectedOption(key);
                        setShowOption(false);
                      }}
                      style={{ height: '35px', background: selectedOption === key ? '#00B595' : undefined }}
                    >
                      {
                        isEnglish ? (
                          <SquadSemiBoldText fontSize={16} lineHeight={35} color={selectedOption === key ? '#FFFFFF' : '#11202B'} marginLeft={20}>
                            Door is not working
                          </SquadSemiBoldText>
                        ) : (
                          <PingFangMediumText fontSize={16} lineHeight={35} color={selectedOption === key ? '#FFFFFF' : '#11202B'} marginLeft={20}>
                            无法打开柜门
                          </PingFangMediumText>
                        )
                      }
                    </div>
                  );
                }
                if (key === 'Other') {
                  return (
                    <div
                      onClick={() => {
                        setSelectedOption(key);
                        setShowOption(false);
                      }}
                      style={{ borderRadius: '0 0 18px 18px', height: '35px', background: selectedOption === key ? '#00B595' : undefined }}
                    >
                      {
                        isEnglish ? (
                          <SquadSemiBoldText fontSize={16} lineHeight={35} color={selectedOption === key ? '#FFFFFF' : '#11202B'} marginLeft={20}>
                            Other
                          </SquadSemiBoldText>
                        ) : (
                          <PingFangMediumText fontSize={16} lineHeight={35} color={selectedOption === key ? '#FFFFFF' : '#11202B'} marginLeft={20}>
                            其他
                          </PingFangMediumText>
                        )
                      }
                    </div>
                  );
                }
              })
            }
          </div>
        )
      }

      {/* Okay按钮 */}
      {
        !showOption && (
          <RowCenter style={{ marginTop: 48 }}>
            <Button
              width={265}
              height={52}
              backgroundColor={!selectedOption ? '#D8D8D8' : '#00B595'}
              borderRadius={50}
              disabled={!selectedOption}
              boxShadow={'0px 22px 30px 0px rgba(0,181,149,0.05)'}
              onClick={() => {
                if (selectedOption) {
                  onConfirm(selectedOption);
                }
              }}
            >
              {
                isEnglish ? (
                  <SquadBoldText fontSize={18} color={'#FFFFFF'}>
                    Submit
                  </SquadBoldText>
                ) : (
                  <PingFangSemiBoldText fontSize={18} color={'#FFFFFF'}>
                    提交
                  </PingFangSemiBoldText>
                )
              }
            </Button>
          </RowCenter>
        )
      }
    </Modal>
  );
};

export interface Props {
  onClose: () => void;
  onConfirm: (reason: string) => void;
  isEnglish: boolean;
  optionKeys: string[];
}

export default ProblemReportModal;
